(function () {
    function initCo2Rechner() {
        var boxes = document.querySelectorAll('.co2-rechner__slider-box');

        boxes.forEach(function (box) {
            var range = box.querySelector('.co2-rechner__range');
            if (!range) return;

            var max = parseInt(range.max) || 15;
            var rechner = box.closest('.co2-rechner');
            var co2PerTruck = parseInt(box.dataset.co2) || 12;

            var thumbLabel = box.querySelector('.co2-rechner__range-thumb-label');
            var trucksContainer = box.querySelector('.co2-rechner__trucks');
            var currentNum = box.querySelector('.co2-rechner__current-num');

            var resultNum = rechner.querySelector('.co2-rechner__result-num');
            var resultSub = rechner.querySelector('.co2-rechner__result-sub');
            var sliderLabel = box.querySelector('.co2-rechner__current-label');
            var baseSliderLabel = sliderLabel ? sliderLabel.textContent.trim() : '';
            var tiles = rechner.querySelectorAll('.co2-rechner__tile-value');

            // Trucks dynamisch generieren (1 bis max)
            trucksContainer.innerHTML = '';
            for (var t = 1; t <= max; t++) {
                var span = document.createElement('span');
                span.className = 'co2-rechner__truck';
                span.dataset.index = t;
                span.setAttribute('aria-hidden', 'true');
                span.innerHTML = [
                    '<svg class="co2-rechner__truck-icon" viewBox="0 0 64 36" focusable="false">',
                    '<path class="co2-rechner__truck-shadow" d="M8 31h48" />',
                    '<path class="co2-rechner__truck-trailer" d="M5 8.5h32.5v16H5z" />',
                    '<path class="co2-rechner__truck-cab" d="M37.5 13h9.5l6.5 6.5v5H37.5z" />',
                    '<path class="co2-rechner__truck-window" d="M43 15.5h3.5l3 3H43z" />',
                    '<path class="co2-rechner__truck-line" d="M11 14h20" />',
                    '<circle class="co2-rechner__truck-wheel" cx="17" cy="27" r="4.5" />',
                    '<circle class="co2-rechner__truck-wheel" cx="44.5" cy="27" r="4.5" />',
                    '</svg>',
                ].join('');
                trucksContainer.appendChild(span);
            }
            var trucks = trucksContainer.querySelectorAll('.co2-rechner__truck');

            function formatNumber(n) {
                return n.toLocaleString('de-DE');
            }

            function getThumbPos(val, trackWidth) {
                var thumbSize = 48; // 3rem in px
                var rangeRect = range.getBoundingClientRect();
                var wrapRect = range.parentElement.getBoundingClientRect();
                var rangeOffset = rangeRect.left - wrapRect.left;
                return rangeOffset + (val / max) * (trackWidth - thumbSize) + (thumbSize / 2);
            }

            function positionTrucks(trackWidth) {
                var thumbSize = 48;
                trucks.forEach(function (truck, i) {
                    var step = i + 1; // 1-basiert
                    var centerX = (step / max) * (trackWidth - thumbSize) + (thumbSize / 2);
                    truck.style.left = centerX + 'px';
                });
            }

            function update() {
                var val = parseInt(range.value);
                var co2Total = val * co2PerTruck;
                var trackWidth = range.offsetWidth;
                var thumbSize = 48;

                // Thumb label – absolut zentriert im Kreis
                if (thumbLabel) {
                    var thumbLeft = getThumbPos(val, trackWidth);
                    thumbLabel.style.left = thumbLeft + 'px';
                    thumbLabel.textContent = val;
                }

                // Range fill
                var fillPct = (val / max) * 100;
                range.style.background = 'linear-gradient(to right, #008e4d 0%, #008e4d ' + fillPct + '%, #e0e5e0 ' + fillPct + '%, #e0e5e0 100%)';

                // Truck icons positionieren und aktiv setzen
                positionTrucks(trackWidth);
                trucks.forEach(function (truck, i) {
                    if ((i + 1) <= val) {
                        truck.classList.add('active');
                    } else {
                        truck.classList.remove('active');
                    }
                });

                // Current number
                if (currentNum) currentNum.textContent = val;
                if (sliderLabel) sliderLabel.textContent = 'von ' + max + ' ' + baseSliderLabel;

                // Result
                if (resultNum) resultNum.textContent = formatNumber(co2Total);
                if (resultSub && baseSliderLabel !== '') {
                    resultSub.textContent = 'mit ' + val + ' ' + baseSliderLabel;
                }

                // Tiles (fix: 4800 Liter Diesel, 48000 km pro LKW)
                var fixedFactors = [4800, 48000];
                tiles.forEach(function (tile, i) {
                    var factor = fixedFactors[i] || 0;
                    tile.textContent = formatNumber(val * factor);
                });
            }

            range.addEventListener('input', update);
            window.addEventListener('resize', update);

            // Initial mit value=1 – nach Render
            range.value = 1;
            requestAnimationFrame(function () {
                requestAnimationFrame(update);
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCo2Rechner);
    } else {
        initCo2Rechner();
    }
})();
